import { create } from 'zustand';

interface CalendarEvent {
  title: string;
  start: Date;
  end: Date;
  allDay: boolean;
  resource: any;
}

interface CalendarStore {
  events: CalendarEvent[];
  setEvents: (events: CalendarEvent[]) => void;
  removeEvent: (postId: string) => void;
}

export const useCalendarStore = create<CalendarStore>((set) => ({
  events: [],
  setEvents: (events) => set({ events }),
  removeEvent: (postId) =>
    set((state) => ({
      events: state.events.filter((event) => event.resource.id !== postId),
    })),
}));
